export const studentConstants = {

    FETCH_STUDENTSLIST_REQUEST: 'FETCH_STUDENTSLIST_REQUEST',
    FETCH_STUDENTSLIST_SUCCESS: 'FETCH_STUDENTSLIST_SUCCESS',
    FETCH_STUDENTSLIST_FAILURE: 'FETCH_STUDENTSLIST_FAILURE',

}